const DESKTOP_BREAKPOINT_QUERY = '(min-width: 768px)'

function parseColumns(value?: string | number | null): number | null {
  if (value === undefined || value === null || value === 'auto') return null
  const parsed = typeof value === 'number' ? value : parseFloat(value)
  return Number.isNaN(parsed) ? null : parsed
}

export function isDesktopCarouselBreakpoint(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(DESKTOP_BREAKPOINT_QUERY).matches
}

export function shouldHideCarouselArrows(cellCount: number, columns?: string | number | null, columnsMb?: string | number | null): boolean {
  const columnsForBreakpoint = isDesktopCarouselBreakpoint() ? columns : columnsMb
  const parsedColumns = parseColumns(columnsForBreakpoint)
  if (parsedColumns === null) return false
  return cellCount <= parsedColumns
}
